const single_sign_on = {
    forbidden_domains: 'Öffentliche E-Mail-Domänen sind nicht erlaubt.',
    duplicated_domains: 'Es gibt doppelte Domänen.',
    /** UNTRANSLATED */
    invalid_domain_format: 'Invalid domain format.',
    /** UNTRANSLATED */
    duplicate_connector_name: 'Connector name already exists. Please choose a different name.',
};
export default Object.freeze(single_sign_on);
